import { ThemeConfig } from "antd";

const theme: ThemeConfig = {
    token: {
        colorPrimary: '#144075',
        borderRadius: 3,
    },
    components: {
        Button: {
            borderRadius: 56,
            paddingInline: 73,
            algorithm: true,
            fontSize: 16,
            fontWeight: 600,
            'primaryShadow': 'none',
        },
    }
}

export default theme;